import { FC } from 'react';

import { Button, Divider } from '@hh.ru/magritte-ui';
import { Link as SPALink } from '@hh.ru/redux-spa-middleware';

import { CampaignActionsMenuItem } from 'components/CampaignsDashboard/hooks/useCampaignActionsMenuItems';
import useTrls from 'hooks/translation/useTrls';

interface CampaignActionsListProps {
    campaignId: number;
    actionsMenuItems: CampaignActionsMenuItem[];
    sudoActionsMenuItems: CampaignActionsMenuItem[];
    isSudo: boolean;
    dataQaPrefix: 'campaign-action' | 'campaign-mobile-action';
    onAction: () => void;
    className?: string;
}

export const CampaignActionsList: FC<CampaignActionsListProps> = ({
    campaignId,
    actionsMenuItems,
    sudoActionsMenuItems,
    isSudo,
    dataQaPrefix,
    onAction,
    className,
}) => {
    const trls = useTrls();

    const renderItems = (items: CampaignActionsMenuItem[]) =>
        items.map(({ key, trlKey, icon: Icon, disabled, to, buttonStyle = 'neutral', onClick }) => {
            const commonButtonProps = {
                'data-qa': `${dataQaPrefix}-${key}-${campaignId}`,
                stretched: true,
                size: 'large' as const,
                style: buttonStyle,
                mode: 'tertiary' as const,
                disabled,
                icon: <Icon />,
                onClick: () => {
                    onClick?.();
                    onAction();
                },
            };

            return (
                <li key={key} role="menuitem">
                    {to ? (
                        <Button {...commonButtonProps} Element={SPALink} to={to} target="_blank">
                            {trls(trlKey)}
                        </Button>
                    ) : (
                        <Button {...commonButtonProps}>{trls(trlKey)}</Button>
                    )}
                </li>
            );
        });

    return (
        <ul className={className} role="menu" aria-orientation="vertical">
            {renderItems(actionsMenuItems.filter((item) => item.visible))}
            {isSudo && (
                <>
                    <li role="separator">
                        <Divider marginTop={8} marginBottom={8} />
                    </li>
                    {renderItems(sudoActionsMenuItems)}
                </>
            )}
        </ul>
    );
};
